var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":_vm.placeholder,"allowClear":"","value":_vm.equationId},on:{"change":_vm.onChange}},_vm._l((_vm.equationList),function(lo){return _c('a-select-option',{key:lo.id,attrs:{"value":lo.id}},[_vm._v(" "+_vm._s(lo.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }